// @mui
import {
  Box,
  Stack,
  TextField,
  Typography,
  TextareaAutosize,
} from "@mui/material";
import { FieldErrors, UseFormRegister } from "react-hook-form";
// styling
import styles from "src/components/UI/Profile/assets/scss/Profile.module.scss";

interface FormObject {
  user_name: any;
  profession: any;
  first_name: any;
  last_name: any;
  email: any;
  bio: any;
  street: any;
  city: any;
  state: any;
  country: any;
  zip_code: any;
}
interface PersonalInfoEditProps {
  errors: FieldErrors<FormObject>;
  register: UseFormRegister<FormObject>;
}
const PersonalInfoEdit = ({ errors, register }: PersonalInfoEditProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1} alignItems="flex-start" sx={{ p: 0 }}>
        <Box
          sx={{
            width: "100%",
          }}
          rowGap={1}
          columnGap={1}
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
        >
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              First name
            </Typography>
            <TextField
              {...register("first_name", {
                required: "First name is required.",
                pattern: {
                  value: /^[A-Za-z][A-Za-z]*$/,
                  message:
                    "First name should begin with a letter. First name accepts letters only.",
                },
                minLength: {
                  value: 3,
                  message: "First name should be at least 3 characters.",
                },
                maxLength: {
                  value: 16,
                  message: "First name should not exceed 16 characters.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.first_name}
              helperText={errors.first_name?.message?.toString()}
            />
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Last name
            </Typography>
            <TextField
              {...register("last_name", {
                required: "Last name is required.",
                pattern: {
                  value: /^[A-Za-z][A-Za-z]*$/,
                  message:
                    "Last name should begin with a letter. Last name accepts letters only.",
                },
                minLength: {
                  value: 3,
                  message: "Last name should be at least 3 characters.",
                },
                maxLength: {
                  value: 16,
                  message: "Last name should not exceed 16 characters.",
                },
              })}
              type="text"
              className={styles.editField}
              error={!!errors.last_name}
              helperText={errors.last_name?.message?.toString()}
            />
          </div>
        </Box>
        <div className={styles.detailsItem}>
          <Typography className={styles.detailsInfoHead} variant="subtitle2">
            Email address
          </Typography>
          <TextField
            {...register("email", {
              required: "Email address is required.",
              pattern: {
                value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i,
                message: "Invalid email format.",
              },
            })}
            type="text"
            className={styles.editField}
            error={!!errors.email}
            helperText={errors.email?.message?.toString()}
          />
        </div>
        <div className={`${styles.detailsItem}`} style={{ maxWidth: "97.5vw" }}>
          <Typography className={styles.detailsInfoHead} variant="subtitle2">
            Bio
          </Typography>

          <TextField
            {...register("bio")}
            type="text"
            className={styles.editBioField}
            error={!!errors.bio}
            helperText={errors.bio?.message?.toString()}
            inputProps={{ maxLength: 150 }}
            multiline={true}
          />
        </div>
      </Stack>
    </Box>
  );
};
export default PersonalInfoEdit;
